import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { hm12, todayISO, fmtDate, fmtTime12 } from "@/lib/format";
import { toast } from "sonner";
import { Scissors, ArrowLeft, Loader2 } from "lucide-react";

export default function Reschedule() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [appt, setAppt] = useState(null);
  const [date, setDate] = useState(todayISO());
  const [slots, setSlots] = useState([]);
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get(`/public/appointment/${id}`).then((r) => { setAppt(r.data); setDate(r.data.date); }); }, [id]);

  useEffect(() => {
    if (!appt) return;
    setLoading(true); setTime("");
    api.get(`/public/availability?service_id=${appt.service_id}&barber_id=${appt.barber_id}&date=${date}`)
      .then((r) => setSlots(r.data.slots)).finally(() => setLoading(false));
  }, [appt, date]);

  const save = async () => {
    setSaving(true);
    try { await api.post(`/public/appointment/${id}/reschedule`, { date, time }); toast.success("Cita reagendada"); navigate(`/booking-success/${id}`); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  if (!appt) return <div className="min-h-screen flex items-center justify-center bg-[#0f0f0f]"><Loader2 className="w-8 h-8 text-[#d4af37] animate-spin" /></div>;

  return (
    <div className="min-h-screen bg-[#0f0f0f] text-[#f5f5f5]">
      <header className="border-b border-[#2a2a2a] h-16 flex items-center px-5">
        <Link to={`/booking-success/${id}`} className="flex items-center gap-2 text-[#a3a3a3]"><ArrowLeft className="w-4 h-4" /><Scissors className="w-5 h-5 text-[#d4af37]" /><span className="font-bold">NAKAMA</span></Link>
      </header>
      <div className="max-w-lg mx-auto px-5 py-8">
        <h1 className="text-2xl font-extrabold mb-1">Reagendar cita</h1>
        <p className="text-[#737373] text-sm mb-6">Actual: {fmtDate(appt.start)} a las {fmtTime12(appt.start)} · {appt.barber_name}</p>
        <label className="text-sm text-[#a3a3a3] mb-1.5 block">Nuevo día</label>
        <input type="date" min={todayISO()} value={date} onChange={(e) => setDate(e.target.value)} className="nk-input max-w-xs mb-6" data-testid="resch-date" />
        {loading ? <Loader2 className="w-5 h-5 animate-spin text-[#737373]" /> : slots.length === 0 ? <p className="text-[#737373]">Sin horarios disponibles.</p> : (
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
            {slots.map((s) => <button key={s} onClick={() => setTime(s)} data-testid={`resch-slot-${s}`}
              className={`py-2.5 rounded-[10px] text-sm ${time === s ? "bg-[#d4af37] text-black" : "bg-[#242424] hover:bg-[#2f2f2f]"}`}>{hm12(s)}</button>)}
          </div>
        )}
        <button onClick={save} disabled={!time || saving} className="nk-btn w-full mt-8 flex items-center justify-center gap-2" data-testid="resch-save">
          {saving && <Loader2 className="w-4 h-4 animate-spin" />}Guardar cambios
        </button>
      </div>
    </div>
  );
}
